module.exports = __webpack_public_path__ + "static/img/icon_cang.c313d609.png";